import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;

document.addEventListener('DOMContentLoaded', () => {
  const historicalLink = document.getElementById('historical-link');
  if (historicalLink) {
    historicalLink.hidden = document.body.dataset.isAdmin !== 'true';
  }
});
